import moment from "moment";
import { Line } from "rc-progress";
import MapHook from "../utils/MapHook";
import PrintSVG from "../assets/images/svgs/printer.svg";
import CompletedSVG from "../assets/images/svgs/Frame.svg";
import { formatInvoiceDetails, getUserJourneyDates, toTitleCase } from "../utils/LogicHelper";
import pdfGenerateReceipt from "../utils/pdfGenerateReceipt";


const Success = ({ tripDetails }) => {

  const timeline = (tripDetails && Array.isArray(tripDetails.user_journey))
    ? getUserJourneyDates(tripDetails)
    : null;
  //const timeline = getUserJourneyDates(tripDetails);
  const tripJourney = tripDetails.user_journey;

  // const lineProgressStatus = () => {
  // 	if(timeline["COMPLETED"]) return 100;
  // 	else if(timeline["TRIP-STARTED"] && !timeline["COMPLETED"]) return 65;
  // 	else if(tripDetails["is_paid"] && !timeline["TRIP-STARTED"] && !timeline["COMPLETED"])
  // 		return 35;
  // 	else return 20;
  // };

  const lineProgressStatus = () => {
    if (!timeline) return 0;
    if (timeline["COMPLETED"]) return 100;
    else if (timeline["TRIP-STARTED"] && !timeline["COMPLETED"]) return 65;
    else if (tripDetails["is_paid"] && !timeline["TRIP-STARTED"] && !timeline["COMPLETED"])
      return 35;
    else return 20;
  };

  // const getLastUpdate = () => {
  //   let lastStatus =
  //     tripDetails["user_journey"][tripDetails["user_journey"].length - 1];
  //   return moment(lastStatus.time).format("LLLL");
  // };

  const getLastUpdate = () => {
    if (
      tripDetails &&
      Array.isArray(tripDetails.user_journey) &&
      tripDetails.user_journey.length > 0
    ) {
      const lastStatus = tripDetails.user_journey[tripDetails.user_journey.length - 1];
      return moment(lastStatus.time).format("LLLL");
    }
    return "-";
  };

  const generateReceipt = () => {
    const tripInformation = formatInvoiceDetails(tripDetails);
    const organisation = tripDetails.organisation
    pdfGenerateReceipt(tripDetails, tripInformation, organisation).catch(err => console.log(err));
  };

  return (
    <section className="overflow-y-auto overflow-x-hidden">
      <div
        className={`flex flex-col justify-center items-center min-h-screen font-Neue`}
      >
        <div className="self-start mt-4 ms-2 lg:ms-[70px] xl:ms-[80px] 2xl:ms-[145px]">
          <p className="text-[#14219E] text-2xl font-semibold mb-2">Track Your Trip</p>
          <p className="text-start text-base font-bold text-[#14219E] mb-2">Reference Number : {tripDetails.reference}</p>
        </div>
        <p className="text-base font-medium text-[#333333] self-start mt-4 ms-2 lg:ms-[70px] xl:ms-[80px] 2xl:ms-[145px]">
          Last update : {getLastUpdate()}
        </p>
        <div className="flex  flex-col-reverse lg:flex-row px-2 pb-4 justify-center items-center w-[100%] lg:w-[90%]">
          <div className="bg-[#F3F6FF] p-2 lg:pe-4 rounded-lg w-full lg:w-1/2 h-[560px] overflow-y-auto">
            {tripDetails.quote &&
              <p className="text-xl text-[#14219E] font-medium flex cursor-pointer mb-4" onClick={generateReceipt}>
                Print Receipt<img className="mx-4" src={PrintSVG} alt="PRINT_RECEIPT" />
              </p>
            }

            <div className="flex flex-row justify-between text-sm pt-4 font-normal text-[#808080] mb-2">
              <p className="text-start"> Delivery Start Date </p>
              <Line
                percent={lineProgressStatus()}
                strokeColor="#76CD68"
                trailColor="#D3D3D3"
                className="mt-2 h-[4px]"
              />
              <p className="text-end">
                {" "}
                {timeline && timeline["COMPLETED"]
                  ? "Delivery End Date"
                  : "Expected Delivery Date"}{" "}
              </p>
            </div>

            <div className="flex flex-row justify-between text-sm font-bold text-[#232323] mb-8">
              <p className="w-1/3">
                {" "}
                {timeline && timeline["INITIATED"]
                  ? moment(timeline["INITIATED"]).format("llll")
                  : "-"}
              </p>
              <p className=" w-1/3 text-end">
                {" "}
                {timeline
                  ? timeline["COMPLETED"]
                    ? moment(timeline["COMPLETED"]).format("llll")
                    : moment(tripDetails["scheduled_date"]).format("llll")
                  : "--"}{" "}
              </p>
            </div>

            <hr className="my-4 bg-[#c9c7c7] h-[1px]" />

            <p className="text-lg font-bold text-[#333333]">Latest Updates</p>
            <div className="flex flex-col mt-5">
              {(tripJourney || []).map((item, index) => (
                <div
                  key={index}
                  className={`flex flex-row w-full justify-between mb-[20px]`}
                >
                  <div className="flex flex-row w-1/2">
                    <img src={CompletedSVG} alt="TRIP_COMPLETED" width={20} height={20} />
                    <p className={`text-sm sm:text-xs font-bold ps-2 text-[#333333] my-auto`}>
                      {toTitleCase(item.message)}
                    </p>
                  </div>
                  <p className="text-sm sm:text-xs my-auto font-medium text-[#808080] w-1/2 text-end">
                    {moment(item.time).format("llll")}
                  </p>
                </div>
              ))}
            </div>
          </div>
          <div className=" w-full lg:w-1/2 py-4 lg:ps-4  rounded-lg">
            <div className="h-[450px] md:h-[555px]">
              <div
                className="text-center"
                style={{ height: "100%", width: "100%" }}
              >
                <MapHook
                  source={tripDetails.source}
                  destination={tripDetails && tripDetails.destination && tripDetails.destination[0] ? tripDetails?.destination[0].address : tripDetails.destination}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Success;